const MaskedCharacter = 'X';

/** Punctuation characters and whitespace don't need to be masked */
const excludeFromMaskRegex = /[+-.()\s]/;
const convertToMask = (char: string) => (excludeFromMaskRegex.test(char) ? char : MaskedCharacter);

export const maskPhoneNumber = (phoneNumber: string | null | undefined): string | undefined => {
  if (!phoneNumber) return;

  const { length } = phoneNumber;
  const lastFour = phoneNumber.slice(length - 4);
  const otherCharacters = phoneNumber.substring(0, length - 4) ?? '';
  const maskedCharacters = [...otherCharacters].map(convertToMask).join('');
  return maskedCharacters.concat(lastFour);
};
